import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import { useMediaQuery } from '../../../../../utils/hooks/useMediaQuery';
import { IImage } from '../../../../../utils/types/contentful';
import { Image } from '../../../../UI/Media/Image';
import './productMainVariantImages.css';

export interface ProductMainVariantImagesProps {
  images: IImage[];
}

export const ProductMainVariantImages: React.FC<ProductMainVariantImagesProps> = ({
  images,
  badges,
}) => {
  const isWindowSmallSize: boolean = useMediaQuery('lg', true);
  const [activeSlide, setActiveSlide] = useState(0);
  const slider1 = useRef();

  const handlePaginationImageItemClick = (index) => {
    slider1.current.slickGoTo(index);
    setActiveSlide(index);
  };

  const returnPaginationImageItem = (image, index) => (
    <li
      onKeyDown={() => handlePaginationImageItemClick(index)}
      onClick={() => handlePaginationImageItemClick(index)}
      value={index}
      className={`my-3 w-10 h-10 lg:w-16 lg:h-16 flex justify-center items-center rounded-full border-2 overflow-hidden ${
        index === 0 ? '' : 'ml-3'
      } ${
        activeSlide === index
          ? 'border-gray-500 opacity-100'
          : 'border-white opacity-40 hover:opacity-70'
      } transform transition-all`}
    >
      <Image
        {...image}
        bgColor='white'
        objectFit='cover'
        height='100%'
        width='100%'
      />
    </li>
  );

  const returnImages = () =>
    images?.map((image, index) => (
      <div
        className={`relative ${
          index === 2 && !isWindowSmallSize ? 'my-16' : ''
        } h-96 md:h-144 lg:h-full`}
        style={{
          maxHeight: '600px',
          height: 'calc(100vh - 300px)',
          minHeight: '500px',
        }}
      >
        <Image {...image} bgColor='white' width='100%' height='100%' />
      </div>
    ));

  return (
    <div className='relative w-full'>
      {/* Main image slider responsive */}
      {isWindowSmallSize ? (
        <Slider
          adaptiveHeight
          ref={(slider) => {
            slider1.current = slider;
          }}
          slidesToShow={1}
          centerMode
          isInfinite
          centerPadding={0}
          nextArrow={<></>}
          prevArrow={<></>}
          afterChange={(index) => {
            setActiveSlide(index);
          }}
        >
          {returnImages()}
        </Slider>
      ) : (
        returnImages()
      )}
      <div className='absolute top-6 left-5'>{badges}</div>
      {isWindowSmallSize && (
        <div className='absolute w-full overflow-scroll no-scrollbar flex justify-start bottom-0 left-0 z-10'>
          <ul className='flex relative cursor-pointer ml-5'>
            {images?.map((image, index) =>
              returnPaginationImageItem(image, index)
            )}
          </ul>
        </div>
      )}
    </div>
  );
};
